export default "__VITE_ASSET__Cbb2bvyq__"